/* eslint-disable react/no-unknown-property */
/** @jsxRuntime classic */
/** @jsx jsx */
import { useRouter } from 'next/router'
import { Box, jsx, Image, Button } from 'theme-ui'
import redirectToPage from '/lib/redirect'
import utils from '/utils'
import useControlNavbar from '/hooks/useControlNavbar'
import { signOut } from 'next-auth/react'

import { NavBar } from '/components/Korea/NavBar'
import Footer from '/components/Korea/Footer'
import styles from './styles'
import Header from '/components/Korea/Header'

const WithKoreaDefaultLayout = (Page) =>
  function Component(props) {
    const router = useRouter()
    const logo = '/static/aia-tth-logo-white.png'
    const [show] = useControlNavbar()

    const { sideMenu, layout, footer, locale } = props?.pageProps ?? {}

    const isMobile = utils.isMobile()

    const pageProps = { ...props, isMobile }

    return (
      <main sx={styles.container}>
        <Box sx={styles.content}>
          <Box sx={show ? styles.menuContainer : styles.hiddenMenuContainer}>
            <NavBar navItems={sideMenu} locale={locale} />
            <Image
              src={logo}
              sx={styles.logo}
              onClick={() => redirectToPage(router, locale, '/')}
            />
            <Button
              sx={styles.logOutButton}
              onClick={() => signOut({ callbackUrl: `/${locale}` })}
            >
              Log out
            </Button>
          </Box>
          <Header
            sideMenu={sideMenu}
            layout={layout}
            locale={locale}
            isMobile={isMobile}
          />
          <Box sx={styles.pageWrapper}>
            <Page {...pageProps} />
          </Box>
        </Box>
        {footer && <Footer cmsContent={footer} locale={locale} />}
        <div data-iframe-height="1"></div>
      </main>
    )
  }

export default WithKoreaDefaultLayout
